




















    import {Vue, Component, Mixins, Prop} from 'vue-property-decorator';

	import TextHeader from '@/components/Common/TextHeader.vue';
	import IconPdf from '@/components/Icons/IconPdf.vue';
	import LogoRosneft from '@/components/Icons/LogoRosneft.vue';
    import BaseComponent from "@/plugins/BaseComponent";

    import { Hooper, Slide } from 'hooper';
    import 'hooper/dist/hooper.css';
    import {Controller} from "@/plugins/Controller";
    import {Endpoints} from "@/plugins/endpoints";

	@Component({
		components: {
		    TextHeader,
            Hooper,
			Slide
		}
	})
	export default class Clients extends Mixins(BaseComponent) {
		@Prop({type: Boolean, default: false})
		outlined: boolean;

        private items: any[] = [];
        private controller: Controller = new Controller();
        private breakpoints = {breakpoints: {
                200: {
                    itemsToShow: 1,
                },
				400: {
					itemsToShow: 2,
				},
				800: {
					itemsToShow: 4,
				},
				1000: {
					itemsToShow: 6,
				}
        	}
        }

        mounted(){
            this.showLoader();
            this.controller.GetClients()
                .then(this.gotData)
                .catch(this.hideLoader)
        }

        gotData(response:any){
            this.hideLoader()
            this.items = response?.data;
            console.log(response);
        }

        getImageUrl(item: any): string{
            return Endpoints.File_Download(JSON.parse(item.value.Logo).id);
		}
	}
